import React from "react";

import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Alert, Button} from "reactstrap";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
import {confirmAlert} from "react-confirm-alert";
import API from "@beardeddevops/react.api";
import CollectionOverride from "components/CollectionOverride";

class FirearmTrace extends CollectionOverride {
	static propTypes = {
		...Framework.Components.Collection.propTypes,
		kioskMode: PropTypes.any,
	};

	constructor(props) {
		super(props, Types.Products._name);
		this.state.serial_numbers = this.props.history.location.search.split('=')[1];
		this.request = 'GET_FIREARM_TRACE'

	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if(this.props.history.location.search.split('=')[1] !== this.state.serial_numbers){
			this.state.serial_numbers = this.props.history.location.search.split('=')[1];
			this.fetchData().then();
		}
	}


	render() {
		const {data, pages, limit, loading} = this.state;
		const extraColumns = [
			{
				Header: 'Acquisition ID',
				accessor: 'transaction_in_id',
				// show: !!this.state['column_transaction_in_id'],
				toggle: 'column_transaction_in_id'
			},
			{
				Header: 'Disposition ID',
				accessor: 'transaction_out_id',
				show: !!this.state['column_transaction_out_id'],
				toggle: 'column_transaction_out_id'
			},
			{
				Header: 'Disposition ID Override',
				accessor: 'manual_4473',
				show: !!this.state['column_manual_4473'],
				toggle: 'column_manual_4473'
			}
		];

		const columns = [
			{
				Header: "Product",
				columns: [
					{
						Header: 'Manufacturer',
						accessor: 'manufacturer',
					},
					{
						Header: 'Model',
						accessor: 'model',
					},
					{
						Header: 'Type',
						accessor: 'type',
					},
					{
						Header: 'Caliber',
						accessor: 'caliber',
					},
					{
						Header: 'Serial',
						accessor: 'serial_number',
					},
					{
						Header: 'Notes',
						accessor: 'item_description',
					},
				],
			},
			{
				Header: "Acquired",
				columns: [
					extraColumns[0],
					{
						Header: 'Date In',
						id: 'date_in',
						/** @param {Bound_Books_Object} obj */
						accessor: obj => moment(obj.date_in)
							.local()
							.format("MM/DD/YYYY"),
					},
					{
						Header: 'From',
						id: 'in_from',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.importer_name ? obj.importer_name : (obj.in_from_type === 'dealer' || obj.in_from_type === 'location') ? (obj.in_from + ' (' + obj.in_from_ffl + ')') : obj.in_from
					}

				]
			},
			{
				Header: "Disposed",
				columns: [
					extraColumns[1],
					extraColumns[2],
					{
						Header: 'Date Out',
						id: 'date_out',
						/** @param {Bound_Books_Object} obj */
						accessor: obj => obj.date_out && moment(obj.date_out)
							.local()
							.format("MM/DD/YYYY"),
					},
					{
						Header: 'To',
						id: 'out_to',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.out_to ?
								(obj.out_to_type === 'dealer' ?
									(obj.out_to + ' (' + obj.out_to_ffl + ')') : obj.incident_number ?
										obj.out_to + ' - ' + obj.incident_number
										: obj.out_to)
								: obj.out_to
					},
					{
						Header: 'Address',
						id: 'out_to_address',
						/** @param {Bound_Books_Object} obj */
						accessor: obj =>
							obj.out_to_address && obj.out_to_address + ' ' + obj.out_to_location
					}
				]
			},
			{
				Header: "NICS",
				accessor: 'nics'
			},
			{
				Header: "Location",
				accessor: 'location_name'
			},
			...!this.props.kioskMode ? [{
				Header: "A",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/** @param {Bound_Books_Object} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.transaction_in &&
								<Link to={`/acquisitions/${props.original.transaction_in_binary_id}-${props.original.transaction_in}`}>
									<Tooltip title={'Acquisition'} placement={'top-end'}>
										<Button color="green-meadow" size="sm" block={true}>
											<i className="fa fa-download"/>
										</Button>
									</Tooltip>
								</Link>}
						</span>
					);
				}
			}] : [],
			{
				Header: "D",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				/** @param {Bound_Books_Object} props.original */
				Cell: props => {
					return (
						<span>
							{props.original.status === 'Sold' &&
								<Link to={`/dispositions/${props.original.transaction_out_binary_id}-${props.original.transaction_out}`}>
									<Tooltip title={'Disposition'} placement={'top-end'}>
										<Button  color="green-meadow" size="sm" block={true} >
											<i className="fa fa-upload"/>
										</Button>
									</Tooltip>
								</Link>}
							{props.original.status === 'Lost / Stolen' &&
								<Link to={`/losses/${props.original.transaction_out_binary_id}-${props.original.transaction_out}`}>
									<Tooltip title={'Loss/Stolen'} placement={'top'}>
										<Button color="green-meadow" size="sm" block={true}>
											<i className="fa fa-upload"/>
										</Button>
									</Tooltip>
								</Link>
							}
						</span>
					);
				}
			},
		];
		const {expanded, columnsAnchor} = this.state;
		return (

			<Card>
				<CardContent>
					<Framework.Errors.General isDev={!process.env.production}>

						{typeof this.state.data === 'undefined' && <Alert color="warning">
							No transactions were found with the serial number '{this.state.serial_numbers}', please double check the serial number and try again.
						</Alert>}
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</Framework.Errors.General>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}

export default Framework.Components.withRootState(FirearmTrace);

